module.exports = "<div class=\"loading-stage\">\n  <div class=\"loading-bar\" #loadingBar>\n    {{ getPercentage() }}%\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = 225
// module chunks = 1